export default "__VITE_ASSET__DKGgAU0i__"